<template>
    <rkm-modal
        extra-large
        hide-footer
        ref="RkmModal"
        title="Agendamentos"
    >
        <List
            v-if="model"
            :data="{model}"
            @saved="load"
        />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Others.
import moment from 'moment'

export default {
    components: {List},
    created() {
        this.repositories = {
            gerenciamentoDiario: this.getConectaSusRepository('ambulatorio.gerenciamentoDiario'),
        }
    },
    data: () => ({
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open() {
            this.$refs.RkmModal.show()
            this.load()
        },
        load() {
            this.setLoading()

            this.repositories.gerenciamentoDiario.list({origem: 'agendamento', data: moment().format('DD/MM/YYYY')})
                .then(response => this.model = Object.assign(response.data.model))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, repository, stringCase],
}
</script>